import { createSlice } from "@reduxjs/toolkit";

function readStoredUserId() {
  const raw = localStorage.getItem("userId");
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === "string" ? parsed : String(parsed);
  } catch {
    return raw;
  }
}

const storedUserId = readStoredUserId();

function readStoredThemeMode() {
  const s = localStorage.getItem("themeMode");
  if (s === "dark" || s === "light") return s;
  return "light";
}

const initialState = {
  mode: readStoredThemeMode(),
  userId: storedUserId ? storedUserId : null,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
      localStorage.setItem("themeMode", state.mode);
    },
    setUser: (state, action) => {
      const id = String(action.payload ?? "");
      state.userId = id || null;
      if (id) localStorage.setItem("userId", id);
      else localStorage.removeItem("userId");
    },
    clearUser: (state) => {
      state.userId = null;
      // localStorage'dan userId'yi kaldır
      localStorage.removeItem("userId");
    }
  },
});

export const { setMode, setUser, clearUser } = globalSlice.actions;

export default globalSlice.reducer;
